import React from "react";
const SvgDsLift = props => (
  <svg fill="none" viewBox="0 0 24 25" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M3 5.2a.7.7 0 01.7-.7h11.6a.7.7 0 01.7.7v14.6a.7.7 0 01-.7.7H3.7a.7.7 0 01-.7-.7V5.2zm1 .3h5v14H4v-14zm6 14h5v-14h-5v14zm10-11a.5.5 0 01.4.2l1.5 2a.5.5 0 01-.8.6L20 9.833 18.9 11.3a.5.5 0 01-.8-.6l1.5-2a.5.5 0 01.4-.2zm0 8a.5.5 0 01-.4-.2l-1.5-2a.5.5 0 01.8-.6l1.1 1.467 1.1-1.467a.5.5 0 01.8.6l-1.5 2a.5.5 0 01-.4.2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsLift;
